import React from "react";
import classNames from "classnames";
 
type Props = {
  label?: string;
  id: string;
  name: string;
  type: string;
  required?: Boolean;
  placeholder?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  errorMessage?: string;
  value: string;
  end2end: Boolean;
  suffixIcon?: React.ReactNode;
  prefixIcon?: React.ReactNode;
  // onSuffixClick?: MouseEventHandler<HTMLDivElement>;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
};
export default function SearchInput({
  label,
  value,
  id,
  name,
  type,
  required,
  placeholder,
  onChange,
  errorMessage,
  prefixIcon,
  suffixIcon,
  // onSuffixClick,
  className,
  disabled = false,
  end2end,
 
  onClick,
}: Props) {
  return (
    <>
      <div>
        <div>
          <label className="block font-lato text-sm font-medium text-[#000]">
            {label}
          </label>
          {required && <p className="text-red-500">*</p>}
        </div>
        {end2end ? (
          <>
            <div
              className={classNames(
                "flex mt-1 w-[19rem] px-5 py-3 bg-[#404040] rounded-md shadow-sm focus:ring-0 focus:outline-none",
                className
              )}
            >
              {/* <div className="flex gap-3 w-full items-center "> */}
                <div className="">{prefixIcon}</div>
                <input
                  id={id}
                  type={type}
                  name={name}
                  value={value}
                  onChange={onChange}
                  placeholder={placeholder}
                  className="border-0 !bg-[#404040] text-white outline-none w-full placeholder:text-white placeholder:text-[14px] mx-0"
                  disabled={disabled}
                  onClick={onClick}
                />
              {/* </div> */}
 
              {/* <div>{suffixIcon}</div> */}
            </div>
          </>
        ) : (
          <>
            <div
              className={classNames(
                "flex mt-1 w-full px-4 py-3 bg-[#404040] rounded-md shadow-sm focus:ring-0 focus:outline-none",
                className
              )}
            >
              <div className="flex gap-3 items-center w-full">
                <div className="">{prefixIcon}</div>
                <input
                  id={id}
                  type={type}
                  name={name}
                  value={value}
                  onChange={onChange}
                  placeholder={placeholder}
                  className="border-0 !bg-[#404040] text-white outline-none w-full placeholder:text-white placeholder:text-[14px]"
                  disabled={disabled}
                  onClick={onClick}
                />
              </div>
 
              {/* <div  className="absolute right-5 top-3"> */}
              {/* <div>{suffixIcon}</div> */}
            </div>
          </>
        )}
 
        {errorMessage ? (
          <small className="text-red-600 font-lato">{errorMessage}</small>
        ) : null}
      </div>
    </>
  );
}
 